import { ISearchQueryParams } from "./store.types";


// For Additional Dynamic keys
const isValidValue = (value: any): boolean => {
    if (value === undefined || value === null) return false;

    if (typeof value === "string") {
        return value.trim().length > 0;
    }

    if (Array.isArray(value)) {
        return value.length > 0;
    }

    if (typeof value === "number") {
        return !Number.isNaN(value);
    }

    if (typeof value === "boolean") {
        return true;
    }

    if (typeof value === "object") {
        return Object.keys(value).length > 0;
    }

    return false;
};

export const getSearchQueryParams = (queryParams: ISearchQueryParams): URLSearchParams => {
    const { company_outlet_uuid, page, rowsPerPage, status, date, moduleName, value, subModuleName, tableName,
        columns, advanceFilter, booking_status, pageLimit, filterBy,
        ...dynamicParams // Additional Dynamic keys
    } = queryParams;

    const params = new URLSearchParams();

    if (company_outlet_uuid) params.append("company_outlet_uuid", company_outlet_uuid);

    if (status && status !== "-1") params.append("status", status);
    if (filterBy && filterBy === "create_ts") params.append("dateFilterColumn", filterBy);
    if (date?.fromDate) params.append("from_date", date.fromDate);
    if (date?.toDate) params.append("to_date", date.toDate);

    if (columns?.length && value) {
        params.append("columns", columns.join(","));
        params.append("value", value);
    }

    if (advanceFilter?.length) {
        params.append("advanceFilter", JSON.stringify(advanceFilter));
    }

    if (typeof page === "number") params.append("pageNo", String(page));
    if (typeof rowsPerPage === "number") params.append("itemPerPage", String(rowsPerPage));
    if (typeof pageLimit === "number") params.append("pageLimit", String(pageLimit));

    if (moduleName) params.append("moduleName", moduleName);
    if (subModuleName) params.append("subModuleName", subModuleName);
    if (tableName) params.append("tableName", String(tableName));

    // Additional Dynamic keys ----
    Object.entries(dynamicParams).forEach(([key, value]) => {
        if (!isValidValue(value)) return;
        if (Array.isArray(value)) {
            params.append(key, value.join(","));
        } else if (typeof value === "object") {
            params.append(key, encodeURIComponent(JSON.stringify(value)));
        } else {
            params.append(key, String(value));
        }
    });

    return params;
};


export const getSearchQueryFromParams = (queryParams: ISearchQueryParams): string => {
    const query = getSearchQueryParams(queryParams).toString();
    return query ? `?${query}` : "";
};